import { useContextFallback } from '@prenuvo/halo';

import { ReportIssueHandlerContext } from './report-issue-handler.context';

export const useReportIssueHandler = () => useContextFallback(ReportIssueHandlerContext);
